import { AudioLines } from "lucide-react";

import { MediaMime } from "../../../api/generated/zod";
import { MediaRefsSlot, type MediaRefs } from "./MediaRefsSlot";

const AUDIO_TYPES = MediaMime.options.filter((mime) => mime.startsWith("audio/"));

/** Live's "Audio refs" (#260): a reference video's audios, from the library or an upload. */
export function AudioRefsSlot({ refs }: { refs: MediaRefs }) {
  return (
    <MediaRefsSlot
      label="Audio refs"
      tag="Audio"
      icon={<AudioLines size={20} strokeWidth={1.5} aria-hidden />}
      accept={AUDIO_TYPES}
      refs={refs}
    />
  );
}
